import { render } from "./invoicePaymentDateDialog.vue?vue&type=template&id=38127e50"
import script from "./invoicePaymentDateDialog.vue?vue&type=script&lang=js"
export * from "./invoicePaymentDateDialog.vue?vue&type=script&lang=js"

import "./invoicePaymentDateDialog.vue?vue&type=style&index=0&id=38127e50&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__